import { Figcaption } from './Figcaption.js'
import {
  AsyncImageAttributes,
  ImageDescriptionType,
  ImageMarkupVersion,
} from './types.js'

export const AsyncImageHtmlView = (props: AsyncImageAttributes) => {
  const {
    size,
    align,
    src,
    title,
    app,
    id,
    hasDescription,
    description,
    descriptionType,
  } = props

  const shouldRenderAlt =
    hasDescription &&
    descriptionType === ImageDescriptionType.Alt &&
    description
  const shouldRenderFigcaption =
    hasDescription &&
    (descriptionType === ImageDescriptionType.Caption ||
      descriptionType === ImageDescriptionType.Overlay) &&
    description
  return (
    <figure
      data-type="image"
      data-version={ImageMarkupVersion.V2}
      data-id={id}
      data-app={app}
      data-size={size}
      data-align={align}
    >
      <img
        src={src}
        title={title}
        alt={shouldRenderAlt ? description : undefined}
        data-id={id}
        data-app={app}
      />
      {shouldRenderFigcaption && (
        <Figcaption
          asOverlay={descriptionType === ImageDescriptionType.Overlay}
        >
          {description}
        </Figcaption>
      )}
    </figure>
  )
}
